import mutations from './mutations'
import actions from './actions'

const state = {
  all_activities: [],
  activities: [],
  activity: [],
  deleted_activities: [],
  active_activities: [],
  in_active_activities: [],
  activity_images: [],
  chosenInventory: [],
  local_activity: [],
  availability: [],
  bookedInventory: [],
  availability_schedule: [],
  surge_schedule: []
}

export default {
  state, mutations, actions
}
